// set resource base url to a relative path
// used as pre-entry for all the static examples bundles
import { resourceUrl, setResourceBaseUrl } from '@sick-davinci/glow-utils';

setResourceBaseUrl('./resources');

if (typeof console !== 'undefined') {
  console.log('@sick-davinci/glow resourceBaseUrl =', resourceUrl());
}
